import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function templateUnificadoService() {
  const api = () => useApi()

  function getColumns(params = {}) {
    return api().query(`${URLS.template_unificado_columns}`, params)
  }

  function getTemplate(params) {
    return api().query(`${URLS.template_unificado_campos}`, params)
  }

  function getAvisos(params = {}) {
    return api().query(`${URLS.avisos}`, params)
  }

  function getAnosDisponiveis(params = {}) {
    return api().query(`${URLS.template_unificado_anos_disponiveis}`, params)
  }

  function postMultipleUpdate(data) {
    return api().mutation(
      `${URLS.template_unificado_multiple_update}`,
      'POST',
      data
    )
  }

  function postJustificativas(data) {
    return api().mutation(`${URLS.justificativas}`, 'POST', data)
  }

  function patchJustificativas(data, id) {
    return api().mutation(`${URLS.justificativas}${id}/`, 'PATCH', data)
  }

  function postGrupoTemplateUnificado(data) {
    return api().mutation(
      `${URLS.grupo_template_unificado}`,
      'POST',
      data
    )
  }

  function postValidacoes(data, id) {
    return api().mutation(
      `${URLS.validacoes}${id}/aplicar_validacao/`,
      'POST',
      data
    )
  }

  function postAvisos(data) {
    return api().mutation(`${URLS.avisos}`, 'POST', data)
  }

  return {
    getColumns,
    getTemplate,
    getAvisos,
    getAnosDisponiveis,
    postMultipleUpdate,
    postJustificativas,
    patchJustificativas,
    postGrupoTemplateUnificado,
    postValidacoes,
    postAvisos,
    ...api,
  }
}
